import $ from 'jquery';
import { closest } from 'next/javascripts/modules/dom';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-todo-checklist', {
  mixins: [eventListenerMixin],

  properties: {
    todoUrl: {
      type: String,
    },
  },

  ready() {
    if (closest(this, '[data-archived], [data-not-access], [data-deleted]')) {
      [...this.querySelectorAll('input[type="checkbox"]')]
        .forEach(input => input.setAttribute('disabled', ''));
    }

    if (window.tower.me) {
      window.tower.initCheckItems($(this).find('.check-items'));
    } else {
      // must wait for the `ready` event
      $(document).ready(() => window.tower.initCheckItems($(this).find('.check-items')));
    }

    this.listenTo(document, 'click', (e) => {
      // checklist 在弹窗的情况下单独处理排序
      if (!closest(e.target, '.selector-menu.custom')) return;
      const anchor = closest(e.target, '.selector-option');
      if (!anchor) return;

      this.namespacedTrigger('sort');
      window.simple.popover.destroyAll();
      $.ajax({
        url: this.todoUrl,
        type: 'get',
        dataType: 'script',
        data: {
          view_by: anchor.dataset.value,
          todo_dialog: true,
        },
      });
    });
  },

  disconnected() {
    this.stopListening();
  },
});
